import React, { useEffect, useState } from 'react';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Container, Grid, Card } from '@mui/material';
import Footer from 'src/components/Footer';
import ReferralUsageHeader from './ReferralUsageHeader';
import { ReferralUsageContent } from './ReferralUsageContent';
import { useReferralUsage } from 'src/hooks/useReferralUsage';
import { ReferralCodeUsageResponse } from '../Referral/referral.interface';

const PAGE_SIZE = 30;

const ReferralUsage = () => {
  const { getReferralCodeUsages, loading: apiLoading } = useReferralUsage();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const [usages, setUsages] = useState<ReferralCodeUsageResponse[] | undefined>(undefined);
  const [totalUsages, setTotalUsages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const fetchUsages = async () => {
    setLoading(true);
    try {
      const data = await getReferralCodeUsages({ page, size: rowsPerPage, sort: 'createdAt,desc' });
      if (data) {
        setUsages(data.content);
        setTotalUsages(data.totalElements);
      }
    } catch (error) {
      console.error('Error fetching referral usages:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsages().then()
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (refresh) {
      fetchUsages().then()
    }
  }, [refresh]);

  return (
    <>
      <title>Referral Usage</title>
      <PageTitleWrapper>
        <ReferralUsageHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3}>
          <Grid item xs={12}>
            <Card>
              <ReferralUsageContent
                usages={usages}
                onRefresh={() => setRefresh(!refresh)}
                loading={loading || apiLoading}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default ReferralUsage;
